<template>
  <section v-if="variants.v1 === variant" class="tw-h-[100svh]">
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>

    <video
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-if="vars.mobileBackgroundImage && isMobileDevice"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.backgroundImage"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-25"></div>
    <div class="tw-relative tw-z-10 tw-flex tw-h-full tw-w-full tw-items-end tw-justify-start">
      <div
        class="tw-z-100 tw-my-4 tw-mb-8 tw-flex tw-max-w-[72rem] tw-flex-col tw-gap-2 tw-px-3 tw-py-2 tw-text-start md:tw-px-14 md:tw-py-10 xl:tw-w-[90%] xl:tw-gap-6 xl:tw-px-10"
      >
        <div class="tw-mb-6" v-html="vars.titleHtml"></div>
        <div
          class="tw-flex tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-6 tw-gap-y-3 min-[480px]:tw-flex-row min-[480px]:tw-justify-start md:tw-mt-0 lg:tw-gap-8"
        >
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`herosection-button-${index}`"
            :class="`n-${button.type} tw-w-full tw-justify-center min-[480px]:tw-w-auto`"
            :to="button.link"
            :external="true"
            >{{ button.label }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>

  <section v-if="variants.v2 === variant" class="tw-h-[100svh]">
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>

    <video
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-if="vars.mobileBackgroundImage && isMobileDevice"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.backgroundImage"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-15"></div>
    <div class="container tw-relative tw-z-10 tw-flex tw-h-full tw-w-full tw-items-end tw-justify-start">
      <div
        class="tw-z-100 tw-my-4 tw-mb-8 tw-flex tw-w-full tw-max-w-[72rem] tw-flex-col tw-gap-2 tw-py-2 tw-text-start md:tw-py-10 lg:tw-mb-16 xl:tw-gap-6"
      >
        <div class="tw-mb-8" v-html="displayedText"></div>

        <div
          class="tw-flex tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-6 tw-gap-y-3 min-[480px]:tw-flex-row min-[480px]:tw-justify-start md:tw-mt-0 lg:tw-gap-8"
        >
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`herosection-button-${index}`"
            :class="`n-${button.type} tw-w-full tw-justify-center min-[480px]:tw-w-auto`"
            :to="button.link"
            :external="true"
            >{{ button.label }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>

  <section v-if="variants.v3 === variant" data-anim-wrap class="hero -type-2 js-hero-type-2 !tw-z-[100]">
      <div data-anim-child="fade delay-1" class="hero__bg" data-parallax="0.7">
        <img data-parallax-target :src="vars.backgroundImage" alt="image">
      </div>

      <div data-anim-child="slide-up delay-4" class="container">
        <div class="hero__content">
          <div class="hero__title" v-html="vars.titleHtml"></div>
        </div>
        <!-- Buttons container positioned at the bottom of hero within the same container -->
        <div
          class="tw-absolute -tw-bottom-40 tw-left-0 tw-flex tw-w-full tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-6 tw-gap-y-3 min-[480px]:tw-flex-row min-[480px]:tw-justify-start lg:tw-gap-8"
        >
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`herosection-button-${index}`"
            :class="`n-${button.type} tw-w-full tw-justify-center min-[480px]:tw-w-auto`"
            :to="button.link"
            :external="true"
          >
            {{ button.label }}
          </nuxt-link>
        </div>
      </div>

      <div data-anim-child="fade delay-6">
        <button class="hero__buttonDown" style="background-color: var(--c-primary); font-size: 1.8rem;">
          <i class="icon-right-arrow"></i>
        </button>
      </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'HeroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      currentTitleIndex: 0,
      titleInterval: null as NodeJS.Timeout | null,
      displayedText: '',
      isDeleting: false,
      isTyping: false,
    };
  },

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },

    currentTitle() {
      if (this.vars.title1Html && this.vars.title2Html) {
        return this.currentTitleIndex === 0 ? this.vars.title1Html : this.vars.title2Html;
      }
      return this.vars.titleHtml || '';
    },
  },

  mounted() {
    this.startTitleAnimation();
    this.initializeDisplay();
  },

  beforeUnmount() {
    this.stopTitleAnimation();
  },

  methods: {
    initializeDisplay() {
      if (this.variant === this.variants.v2 && this.vars.title1Html) {
        this.displayedText = this.vars.title1Html;
      } else {
        this.displayedText = this.vars.titleHtml || '';
      }
    },

    startTitleAnimation() {
      // Only start animation for v2 variant and if we have both titles
      if (this.variant === this.variants.v2 && this.vars.title1Html && this.vars.title2Html) {
        this.titleInterval = setInterval(() => {
          this.animateToNextTitle();
        }, 7000); // Change every 4 seconds
      }
    },

    animateToNextTitle() {
      if (this.isTyping) return; // Prevent overlapping animations

      this.isTyping = true;
      this.deleteCurrentText(() => {
        this.currentTitleIndex = (this.currentTitleIndex + 1) % 2;
        this.typeNewText(() => {
          this.isTyping = false;
        });
      });
    },

    deleteCurrentText(callback: () => void) {
      this.isDeleting = true;
      const currentHtml = this.displayedText;

      // Strip HTML tags to get plain text for character counting
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = currentHtml;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';

      let currentLength = plainText.length;

      const deleteInterval = setInterval(() => {
        if (currentLength <= 0) {
          clearInterval(deleteInterval);
          this.displayedText = '';
          this.isDeleting = false;
          callback();
          return;
        }

        // Calculate how much of the original HTML to show based on character count
        const targetLength = currentLength - 1;
        this.displayedText = this.truncateHtmlToLength(currentHtml, targetLength);
        currentLength--;
      }, 20); // Delete speed
    },

    typeNewText(callback: () => void) {
      const targetHtml = this.currentTitle;

      // Strip HTML tags to get plain text for character counting
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = targetHtml;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';

      let currentLength = 0;

      const typeInterval = setInterval(() => {
        if (currentLength >= plainText.length) {
          clearInterval(typeInterval);
          this.displayedText = targetHtml;
          callback();
          return;
        }

        currentLength++;
        this.displayedText = this.truncateHtmlToLength(targetHtml, currentLength);
      }, 40); // Type speed
    },

    truncateHtmlToLength(html: string, targetLength: number): string {
      if (targetLength <= 0) return '';

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const textContent = tempDiv.textContent || tempDiv.innerText || '';

      if (targetLength >= textContent.length) return html;

      // Simple truncation - for more complex HTML, you might need a more sophisticated approach
      const targetText = textContent.substring(0, targetLength);

      // Try to preserve some HTML structure
      let result = '';
      let textSoFar = '';
      let inTag = false;

      for (let i = 0; i < html.length; i++) {
        const char = html[i];

        if (char === '<') {
          inTag = true;
          result += char;
        } else if (char === '>') {
          inTag = false;
          result += char;
        } else if (inTag) {
          result += char;
        } else {
          if (textSoFar.length < targetLength) {
            result += char;
            textSoFar += char;
          } else {
            break;
          }
        }
      }

      return result;
    },

    stopTitleAnimation() {
      if (this.titleInterval) {
        clearInterval(this.titleInterval);
        this.titleInterval = null;
      }
    },
  },

  watch: {
    variant() {
      // Restart animation when variant changes
      this.stopTitleAnimation();
      this.initializeDisplay();
      this.startTitleAnimation();
    },
  },
});
</script>

<style scoped>
/* Smooth opacity transition for deleting phase */
.tw-opacity-50 {
  transition: opacity 0.3s ease-out;
}
</style>
